import { NgClass } from '@angular/common';
import { Component, forwardRef, HostBinding, Input } from '@angular/core';

import { FuseNavigationItem } from '../../../../types';
import { FuseNavVerticalCollapsableComponent } from '../collapsable/collapsable.component';
import { FuseNavVerticalItemComponent } from '../item/item.component';

@Component({
  standalone: true,
  imports: [
    NgClass,
    FuseNavVerticalItemComponent,
    forwardRef(() => FuseNavVerticalGroupComponent),
    forwardRef(() => FuseNavVerticalCollapsableComponent)
  ],
  selector: 'fuse-nav-vertical-group',
  templateUrl: './group.component.html',
  styleUrls: ['./group.component.scss']
})
export class FuseNavVerticalGroupComponent {
  @HostBinding('class')
  classes = 'nav-group nav-item';

  @Input()
  item: FuseNavigationItem;

  /**
   * Constructor
   */
  constructor() {}
}
